module.exports = {
    drawChart: function(chartData) {

      var chart = AmCharts.makeChart("channelReachChartdiv", {
        "type": "pie",
        "innerRadius": "40%",
        "fontSize": 14,
        "thousandsSeparator": ",",
        "startDuration": 1,
        // "angle": 12,
        // "depth3D": 15,
        // "startEffect": "easeInSine",
        // "pullOutEffect": "easeOutSine",
        "pullOutDuration": 1,
        "startRadius": "20%",
        "sequencedAnimation": false,
        "autoResize": true,
        // "maxLabelWidth": 200,
        "labelRadius": -50,
        // "hideLabelsPercent": 9,
        // "balloonText": "<b>[[title]]</b><br>"
        //               + "<span>Conversions:[[transactionsPercent]]%</span><br>"
        //               + "<span>Revenue:[[revenuePercent]]%</span>"
        //               + "<span>New Users:[[newUsersPercent]]%</span><br>",
        "dataProvider": chartData,
        "autoMargins": false,
        "marginBottom": 20,
        "marginLeft": -60,
        "marginRight": 0,
        "marginTop": 20,
        "pullOutRadius" : 0,
        "valueField": "budgetRatio",
        "titleField": "channel",
        "labelText": "[[channel]]<br>[[value]]%",
  			// "theme": "light",
        "legend": {
          "enabled": false,
          "switchable": false,
          "textClickEnabled": true,
          "align": "center",
          "markerType": "circle",
          "position": "right",
          "valueText": "",
          "markerSize": 10
        },
        "colors": [
          "#20a8d8",
          "#ffc107",
          "#4dbd74",
          "#FCD202",
          "#F8FF01",
        ],
      });

    }
}



// WEBPACK FOOTER //
// ./src/views/budget/mediaBudgetResultChart.js